import { BaseErrorLayout } from '@dvb/ui';
import { Button } from '@heroui/react';
import { HeaderBar } from '@school-manage/ui/HeaderBar/HeaderBar';
import { useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

export function FailRecordError() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <>
      <HeaderBar title={t('unsyncedRecord')} />
      <BaseErrorLayout
        actionElement={
          <Button onPress={() => navigate({ to: '/profile' })}>
            {t('back', { ns: 'ui' })}
          </Button>
        }
        className="bg-background w-full"
      />
    </>
  );
}
